export * from './edit-iris-id/edit-iris-id-dialog.component';
